import {Component, ChangeDetectionStrategy, Input, OnInit} from '@angular/core';
import {Product} from "../../../models/product.model";

@Component({
  selector: 'leap-included-products-item',
  templateUrl: './included-products-item.component.html',
  styleUrls: ['./included-products-item.component.less', '../../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncludedProductsItemComponent implements OnInit {
  @Input() product: Product;
  @Input() currencySignsMap: Map<string, string>;

  language: string;
  deliveryFormat: string;
  certificateType: string;
  imageUrl: string;
  currencySign: string;

  constructor() {}

  ngOnInit() {
    const defaultVariant = this.product.productVariants && this.product.productVariants[0];
    this.language = defaultVariant.language;
    this.deliveryFormat = defaultVariant.deliveryFormat;
    this.certificateType = defaultVariant.certificateType;
    this.imageUrl = defaultVariant.renders && defaultVariant.renders.length && defaultVariant.renders[0].mediumImageUri;
    this.currencySign = this.currencySignsMap.get(this.product.pricing.currency);
  }
}
